import loading from '@/assets/images/loader.gif';
// import placeholder from '@/assets/images/placeholder.png';

/**
 * v-lazy 图片懒加载
 * @param el 
 * @param binding 
 */
const getAttribute = (el, binding) => {
    const src = el.getAttribute('src');
    // if(!src){
    //     el.setAttribute('src', placeholder);
    //     return false;
    // }

    el.setAttribute('src', loading);
    const tempImage = new Image();
    tempImage.src = src;
    tempImage.onload = function () {
        el.setAttribute('src',src);
    };

    // tempImage.onerror = () => {
    //     el.setAttribute('src', placeholder);
    // };

    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry) => {
            if(entry.intersectionRatio !== 0) {
                tempImage.src = src;
            }
        });
    });

    observer.observe(el);
}

export default {
    beforeMount(el, binding) {
        getAttribute(el, binding)
    },
    // updated(el, binding) {
    //     checkAuth(el, binding)
    // }
};